import React from "react";
import PropTypes from "prop-types";

import Header from "../components/Header";
import MetaTags from "../components/Header/metaTags";
import Footer from "../components/Footer";
import Organisation from "../components/JsonLD/organisation.jsx";
import "./index.css";
import "../css/color.css";
import "../css/skin.css";
import "../css/utils.css";

import { rhythm } from "../utils/typography";

class TemplateWrapper extends React.Component {
	render() {
		const { location, children, data } = this.props,
			{ siteMetadata } = data.site,
			paddingTop = rhythm(2);

		return (
			<div className="container-outer">
				<MetaTags pathname={location.pathname} siteMetadata={siteMetadata} />
				<Header
					title={siteMetadata.title}
					hideGuides={siteMetadata.hideGuides}
					social={siteMetadata.social}
				/>
				<Organisation siteMetadata={siteMetadata} />
				<div className="container-layout" style={{ paddingTop }}>
					{children()}
				</div>
				<Footer siteMetadata={siteMetadata} />
			</div>
		);
	}
}

TemplateWrapper.propTypes = {
	children: PropTypes.func,
	location: PropTypes.shape({ pathname: PropTypes.string.isRequired }),
	data: PropTypes.shape({
		site: PropTypes.shape({
			siteMetadata: PropTypes.shape({
				email: PropTypes.string.isRequired,
				googleSiteVerification: PropTypes.string.isRequired,
				hideGuides: PropTypes.bool,
				metaTags: PropTypes.array.isRequired,
				siteUrl: PropTypes.string.isRequired,
				social: PropTypes.shape({
					twitter: PropTypes.string.isRequired,
					medium: PropTypes.string,
					linkedin: PropTypes.string.isRequired,
					github: PropTypes.string.isRequired
				}),
				title: PropTypes.string.isRequired
			})
		})
	})
};

export default TemplateWrapper;
// eslint-disable-next-line one-var
export const pageQuery = graphql`
	query LayoutIndexQuery {
		site {
			siteMetadata {
				hideGuides
				email
				googleSiteVerification
				metaTags {
					page
					title
					description
					keywords
				}
				siteUrl
				social {
					twitter
					linkedin
					medium
					github
				}
				title
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js